import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import Axios from "../../../axios/axios";
import { toast } from "react-toastify";

export const RentalSearchSection = ({ initialFilters = {} }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [selectedCategoryObj, setSelectedCategoryObj] = useState(null);

  // Filter brands based on selected category
  const filteredBrands = selectedCategory
    ? brands.filter((b) => String(b.categoryId?._id || b.categoryId) === String(selectedCategory))
    : brands;

  // Filter states
  const [selectedCategory, setSelectedCategory] = useState(initialFilters.categoryId || "");
  const [selectedBrand, setSelectedBrand] = useState(initialFilters.brandId || "");
  const [selectedRentalType, setSelectedRentalType] = useState(initialFilters.rentalType || "");
  useEffect(() => {
    if (
      initialFilters &&
      (initialFilters.categoryId || initialFilters.brandId || initialFilters.rentalType)
    ) {
      setSelectedCategory(initialFilters.categoryId || "");
      setSelectedBrand(initialFilters.brandId || "");
      setSelectedRentalType(initialFilters.rentalType || "");
    }
  }, [initialFilters]);


  // Fetch categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await Axios.get("/categories");
        const rentalCategories = res.data.filter((c) => c.type.includes("rental"));
        setCategories(rentalCategories);
      } catch (error) {
        console.error("Error fetching categories", error);
      }
    };
    fetchCategories();
  }, []);

  // Fetch brands
  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const res = await Axios.get("/type/rental");
        setBrands(res.data);
      } catch (error) {
        console.error("Error fetching brands", error);
      }
    };
    fetchBrands();
  }, []);

  // Search handler
  const handleSearch = async () => {
    if (!selectedRentalType && !selectedCategory && !selectedBrand) {
      toast.warning("Please select at least one filter.", {
        position: "bottom-center",
        autoClose: 5000,
        theme: "light",
      });
      return;
    }

    const filters = {};
    if (selectedRentalType) filters.rentalType = selectedRentalType;
    if (selectedCategory) filters.categoryId = selectedCategory;
    if (selectedBrand) filters.brandId = selectedBrand;

    try {
      setLoading(true);
      const res = await Axios.post(
        `/rental/search?${new URLSearchParams({ ...filters, page: 1, limit: 9 }).toString()}`
      );

      const queryParams = new URLSearchParams(filters).toString();

      if (filters.categoryId) {

        // Check if category has subcategories
        if (selectedCategoryObj?.subcategories?.length > 0) {
          navigate(`/rental/subcategories?${queryParams}`, {
            state: { selectedFilters: filters }
          });
        } else {
          navigate(`/rental/products?${queryParams}`, {
            state: { rentals: res.data.data, selectedFilters: filters, pagination: res.data },
          });
        }

      } else {
        navigate(`/rental/category?${queryParams}`, {
          state: { rentals: res.data.data, selectedFilters: filters, pagination: res.data },
        });
      }

    } catch (error) {
      console.error("Error searching rentals:", error);
      toast.error("An error occurred while fetching rentals.", {
        position: "bottom-center",
        autoClose: 5000,
        theme: "light",
      });
    } finally {
      setLoading(false);
    }
  };

  // Shared select style (same as spare search)
  const selectStyles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #ced4da",
      boxShadow: "none",
      "&:hover": { borderColor: "#adb5bd" },
      minHeight: "38px",
      width: "100%",
    }),
    container: (provided) => ({
      ...provided,
      width: "100%",
    }),
    indicatorSeparator: () => ({ display: "none" }),
  };

  const sectionStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  const style = {
    fontFamily: "Poppins', sans-serif",
    position: "relative",
    fontWeight: 1000,
    color: "#353C4B",
    fontSize: "104px !important",
  };

  return (
    <section id="banner-rental" style={{ width: "60%", alignContent: "center", margin: "auto" }}>
      <div className="banner" style={{ ...sectionStyle, width: '100%', }}>
        <div className="container-fluid d-flex flex-column align-items-center justify-content-center text-center search-part-section"  >

          <div className="bnr-div"  >
            <div className="row no-gutters">
              <div className="col-lg-6 offset-lg-3" style={style}>
                <h1 className="text-uppercase text-center">
                  Find Rentals
                </h1>
                <p>
                  Whether you're a professional  enthusiast,
                  finding the right items has never been easier.
                  Use our precise search tool to locate the exact spare part you
                  need.
                  Search available rental items by type and availability status.
                </p>
              </div>
            </div>

            {/* Search Filters */}
            <div className="row justify-content-center g-2">
              {/* Category */}
              <div className="col-12 col-md-3">
                <Select
                  className="basic-single w-100"
                  classNamePrefix="select"
                  placeholder=" Category"
                  value={
                    categories
                      .map((cat) => ({ value: cat._id, label: cat.name }))
                      .find((c) => c.value === selectedCategory) || null
                  }
                  onChange={(selectedOption) => {
                    setSelectedCategory(selectedOption ? selectedOption.value : "");
                    setSelectedBrand(""); // Reset brand when category changes

                    // Store complete category object so we can check subcategories later
                    const fullCategory = categories.find(c => c._id === selectedOption?.value);
                    setSelectedCategoryObj(fullCategory || null);
                  }}

                  options={categories.map((cat) => ({
                    value: cat._id,
                    label: cat.name,
                  }))}
                  // isClearable
                  styles={selectStyles}
                />
              </div>

              {/* Brand */}
              <div className="col-12 col-md-3">
                <Select
                  className="basic-single w-100"
                  classNamePrefix="select"
                  placeholder=" Brand"
                  value={
                    filteredBrands
                      .map((brand) => ({ value: brand._id, label: brand.name }))
                      .find((b) => b.value === selectedBrand) || null
                  }
                  onChange={(selectedOption) =>
                    setSelectedBrand(selectedOption ? selectedOption.value : "")
                  }
                  options={filteredBrands.map((brand) => ({
                    value: brand._id,
                    label: brand.name,
                  }))}
                  // isClearable
                  styles={selectStyles}
                />
              </div>

              {/* Rental Type */}
              <div className="col-12 col-md-3">
                <Select
                  className="basic-single w-100"
                  classNamePrefix="select"
                  placeholder="  Type"
                  value={
                    [
                      { value: "Tools", label: "Tools" },
                      { value: "Machinery", label: "Machinery" },
                      { value: "Vehicles", label: "Vehicles" },
                      { value: "Construction", label: "Construction" },
                      { value: "Electronics", label: "Electronics" },
                    ].find((r) => r.value === selectedRentalType) || null
                  }
                  onChange={(selectedOption) =>
                    setSelectedRentalType(selectedOption ? selectedOption.value : "")
                  }
                  options={[
                    { value: "Tools", label: "Tools" },
                    { value: "Machinery", label: "Machinery" },
                    { value: "Vehicles", label: "Vehicles" },
                    { value: "Construction", label: "Construction" },
                    { value: "Electronics", label: "Electronics" },
                  ]}
                  // isClearable
                  styles={selectStyles}

                />
              </div>

              {/* Search Button */}
              <div className="col-12 col-md-3 d-flex align-items-center">
                <Link
                  to="#"
                  className="btn search-btn w-100"
                  onClick={handleSearch}
                  disabled={loading}
                >
                  <i className="fa fa-search" aria-hidden="true"></i>&nbsp;&nbsp;
                  {loading ? "Searching..." : "Search"}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
  );
};
